import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App/>, document.getElementById('anycomment-root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js